export enum Constants {
    LOAD_USERS,
    LOAD_USERS_FINISH,

    CREATE_USER,
    CREATE_USER_FINISH,

    REMOVE_USER,
    REMOVE_USER_FINISH,

    EDIT_USER,
    EDIT_USER_FINISH,

    RECOVER_PASSWORD,
    RECOVER_PASSWORD_FINISH,

    LOAD_GROUPS,
    LOAD_GROUPS_FINISH,

    CREATE_GROUP,
    CREATE_GROUP_FINISH,

    UPDATE_GROUP,
    UPDATE_GROUP_FINISH,

    DELETE_GROUP,
    DELETE_GROUP_FINISH,

    LOAD_GROUP_MEMBERS,
    LOAD_GROUP_MEMBERS_FINISH,

    LOAD_USER_MEMBERS,
    LOAD_USER_MEMBERS_FINISH,

    IMPORT_AD_USERS,
    IMPORT_AD_USERS_FINISH
}
